import React from 'react'
import { useState } from 'react'
import { MoonIcon, SunIcon } from '@chakra-ui/icons'
import {
  BrowserRouter as Router,
  NavLink as RouterLink,
} from 'react-router-dom'
import {
  Box,
  Flex,
  HStack,
  IconButton,
  ChakraProvider,
  Avatar,
  Heading,
  AvatarBadge,
  Link as ChakraLink,
  Button,
  Collapse,
  Menu,
  Text,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useMediaQuery,
  useColorModeValue,
  useColorMode,
  Stack,
} from '@chakra-ui/react'
import { HamburgerIcon, CloseIcon, AddIcon } from '@chakra-ui/icons'
import { customTheme } from '../theme'

const navbar = [
  {
    title: 'Home',
    link: '/',
  },
  {
    title: 'About',
    link: '/about',
  },
  {
    title: 'Projects',
    link: '/projects',
  },
  {
    title: 'Contact',
    link: '/contact',
  },
]

const Header = () => {
  const [isOpen, setIsOpen, onClose] = useState(false)
  const { colorMode, toggleColorMode } = useColorMode()
  const [isSmallScreen] = useMediaQuery('(max-width: 767px)')
  const bg = useColorModeValue('linear-gradient(#648880, #293f50)', 'white')
  const color = useColorModeValue('white', 'black')

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const closeMenu = () => {
    setIsOpen(!isOpen)
  }

  return (
    <ChakraProvider theme={customTheme}>
      <Flex
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        bg={bg}
        color={color}
        h={{
          base: '120px',
          sm: '120px',
          md: '120px',
          lg: '150px',
          xl: '150px',
        }}>
        <Box>
          <ChakraLink href='/' _hover={{ textDecoration: 'none' }}>
            <Heading
              className='glitch'
              fontFamily='cursive'
              fontSize={{
                base: '40px',
                sm: '40px',
                md: '40px',
                lg: '50px',
                xl: '50px',
              }}
              ml='20px'>
              Bintus.
            </Heading>
          </ChakraLink>
        </Box>
        {isSmallScreen ? (
          <>
            <IconButton
              icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
              aria-label={isOpen ? 'Close menu' : 'Open menu'}
              variant={isOpen ? 'black' : 'unstyled'}
              color={isOpen && 'black'}
              top={isOpen && '-9'}
              left={isOpen && '-180px'}
              zIndex='1000'
              size='md'
              ml='auto'
              onClick={toggleMenu}
              transition='all 0.3s'
            />

            <Collapse in={isOpen} animateOpacity>
              <Flex
                direction='column'
                align='center'
                mt={isOpen ? 4 : 0}
                mr={isOpen ? '75px' : 0}
                py={isOpen ? 2 : 0}
                px={isOpen ? '40px' : 0}
                bg='gray.100'
                w={isOpen ? '100vw' : '0'}
                overflow={isOpen && 'hidden'}
                display={isOpen ? 'flex' : 'none'}
                position='fixed'
                top='-4'
                left='0'
                bottom='0'
                zIndex='999'
                transition='all 0.3s'>
                {navbar.map((navItem, i) => (
                  <ChakraLink
                    key={i}
                    to={navItem.link}
                    mr={[1, 1, 4, 4]}
                    color='black'
                    as={RouterLink}
                    style={{ textDecoration: 'none' }}
                    p={2}
                    _activeLink={{
                      fontWeight: 'bold',
                      borderBottom: 'solid Olive 1px',
                    }}
                    _hover={{
                      fontWeight: 'bold',
                    }}
                    onClick={closeMenu}>
                    {navItem.title}
                  </ChakraLink>
                ))}
              </Flex>
            </Collapse>
          </>
        ) : (
          <HStack as='nav' display={{ base: 'none', md: 'flex' }}>
            {navbar.map((navItem, i) => (
              <ChakraLink
                to={navItem.link}
                fontSize='20px'
                mx={{
                  base: '0',
                  sm: '0',
                  md: '10px',
                  lg: '20px',
                  xl: '80px',
                }}
                color={color}
                as={RouterLink}
                style={{ textDecoration: 'none' }}
                py={2}
                marginBottom='-5px'
                _activeLink={{
                  fontWeight: 'bold',
                  borderBottom: 'solid Olive 2px',
                  lineHeight: '50px',
                }}
                className='navbar'
                _hover={{
                  fontWeight: 'bold',
                }}>
                {navItem.title}
              </ChakraLink>
            ))}
          </HStack>
        )}
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          mr={{
            base: '20px',
            sm: '20px',
            md: '20px',
            lg: '30px',
            xl: '30px',
          }}>
          <Button onClick={() => toggleColorMode()} bg='transparent'>
            {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
          </Button>
          <Menu>
            <MenuButton
              as='button'
              rounded='full'
              variant={'link'}
              cursor={'pointer'}
              minW={0}>
              <Avatar
                borderRadius='50%'
                w={{
                  base: '50px',
                  sm: '50px',
                  md: '50px',
                  lg: '70px',
                  xl: '70px',
                }}
                h={{
                  base: '50px',
                  sm: '50px',
                  md: '50px',
                  lg: '70px',
                  xl: '70px',
                }}
                size={'sm'}
                name='Bintus'
                src='/avatar.jpg'
              />
            </MenuButton>
            <MenuList color='black' bg='white'>
              <MenuItem bg='white'>
                <h2>My Socials</h2>
              </MenuItem>
              <MenuDivider />

              <MenuItem bg='white'>
                <a href='https://github.com/bintus-ux'>
                  <i className='fa-brands fa-github'> Github</i>
                </a>
              </MenuItem>
              <MenuItem bg='white'>
                {' '}
                <a href='https://www.linkedin.com/in/calebeze/'>
                  <i className='fa-brands fa-linkedin'> linkedin</i>
                </a>
              </MenuItem>
              <MenuItem bg='white'>
                {' '}
                <a href='mailto:cezerike@gmail.com'>
                  <i className='fa-solid fa-envelope'> Gmail</i>
                </a>
              </MenuItem>
              <MenuItem bg='white'>
                {' '}
                <a href='https://x.com/BintusCal?s=20'>
                  <i className='fa-brands fa-twitter'> Twitter</i>
                </a>
              </MenuItem>

              <MenuItem bg='white'>
                {' '}
                <a href='https://cezerike.medium.com/'>
                  <i className='fa-brands fa-medium'> Medium</i>
                </a>
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>
      </Flex>
    </ChakraProvider>
  )
}

export default Header
